import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})

export class LoggerService {

    debugMode:boolean = false;

    i(className,data){
      if(this.debugMode)
        console.debug("class: "+className+" - "+data);
    }

    e(className,data){
      if(this.debugMode)
        console.error("class: "+className+" - "+data);
    }

    w(className,data){
      if(this.debugMode)
        console.warn("class: "+className+" - "+data);
    }

    d(className,data){
      if(this.debugMode)
        console.debug("class: "+className+" - "+data);
    }

    log(data){
      if(this.debugMode)
        console.log(data);
    }

    test(data){
      if(this.debugMode)
        console.log(data);
    }

  //   i(className,data){
  //    // console.debug("class: "+className+" - "+data);
  //   }

  //   e(className,data){
  //    // console.error("class: "+className+" - "+data);
  //   }

  //   w(className,data){
  //     //console.warn("class: "+className+" - "+data);
  //   }

  //   d(className,data){
  //    // console.debug("class: "+className+" - "+data);
  //   }

  //   log(data){
  //  //   console.log(data);
  //   }

  //   test(data){
  //  //   console.log(data);
  //   }
}
